"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptySessionState = exports.BLITZLESEN_PRESENTATION_LATENCY_MS = exports.SESSION_COMMAND_TYPES = void 0;
exports.isActiveBlitzlesenRun = isActiveBlitzlesenRun;
exports.reduceSessionState = reduceSessionState;
exports.applySessionEvent = applySessionEvent;
exports.applySessionSync = applySessionSync;
__exportStar(require("./whiteboard"), exports);
exports.SESSION_COMMAND_TYPES = ["route.set", "exercise.control", "exercise.input", "exercise.answer", "blitzlesen.fullscreen"];
exports.BLITZLESEN_PRESENTATION_LATENCY_MS = 150;
const emptySessionState = () => ({ route: null, exercise: null });
exports.emptySessionState = emptySessionState;
function objectValue(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value) ? value : null;
}
function exercisePayloadWithPreviousRun(previous, next) {
    const previousPayload = objectValue(previous);
    const nextPayload = objectValue(next);
    const previousState = objectValue(previousPayload?.state);
    const nextState = objectValue(nextPayload?.state);
    if (!previousPayload || !nextPayload || !previousState || !nextState || nextState.run !== undefined)
        return next;
    const previousRunId = previousPayload.runId ?? previousState.runId;
    const nextRunId = nextPayload.runId ?? nextState.runId;
    if (previousPayload.exerciseType !== nextPayload.exerciseType || previousPayload.pageId !== nextPayload.pageId
        || previousRunId !== nextRunId || previousState.run === undefined)
        return next;
    return { ...nextPayload, state: { ...nextState, run: previousState.run } };
}
function isActiveBlitzlesenRun(payload, target) {
    const exercise = objectValue(payload);
    const state = objectValue(exercise?.state);
    return exercise?.exerciseType === "blitzlesen" && exercise.pageId === target.pageId
        && (exercise.runId ?? state?.runId) === target.runId
        && (state?.phase === "ready" || state?.phase === "showing" || state?.phase === "rating");
}
function reduceSessionState(state, type, payload) {
    if (type === "route.set") {
        const route = String(payload?.slug ?? "");
        return { ...state, route, ...(state.blitzlesenFullscreen && route !== state.route ? { blitzlesenFullscreen: null } : {}) };
    }
    if (type === "blitzlesen.fullscreen") {
        const command = payload;
        if (!isActiveBlitzlesenRun(state.exercise, command))
            return state;
        if (!command.enabled)
            return { ...state, blitzlesenFullscreen: null };
        if (!command.activationId)
            return state;
        return { ...state, blitzlesenFullscreen: { pageId: command.pageId, runId: command.runId, activationId: command.activationId } };
    }
    if (type === "exercise.control" || type === "exercise.input" || type === "exercise.answer") {
        const exercise = exercisePayloadWithPreviousRun(state.exercise, payload);
        return { ...state, exercise, ...(state.blitzlesenFullscreen && !isActiveBlitzlesenRun(exercise, state.blitzlesenFullscreen)
                ? { blitzlesenFullscreen: null } : {}) };
    }
    return state;
}
function applySessionEvent(current, event) {
    if (event.revision <= current.revision)
        return current;
    if (event.revision !== current.revision + 1)
        return current;
    return {
        revision: event.revision,
        state: reduceSessionState(current.state, event.type, event.payload),
    };
}
function applySessionSync(current, sync) {
    let next = current;
    if (sync.snapshot && sync.snapshot.revision >= current.revision) {
        next = { revision: sync.snapshot.revision, state: structuredClone(sync.snapshot.state) };
    }
    for (const event of [...sync.events].sort((left, right) => left.revision - right.revision)) {
        next = applySessionEvent(next, event);
    }
    return next;
}
//# sourceMappingURL=index.js.map